<template>
  <div>
	<div class="exportImport">
		<span class="exportStyle" @click="exportData">导出</span>
		<span class="importStyle" @click="importData">导入</span>
	</div>
    <!-- <router-view></router-view> -->
    <el-container  class="conent">
      <div class="aside scroll-body">
        <el-tabs v-model="activeTabsName" type="border-card">
          <el-tab-pane label="题型" name="first">
            <QuestionTypeList 
              :typeObj="typeObj"
              @commonTopic="commonTopic"
              :type="'ks'"
              @batchAddQues="batchAddQues"
            ></QuestionTypeList>
          </el-tab-pane>
          <el-tab-pane label="题库" name="second">
            <QuestionBankList
              @quesFormBand="quesFormBand"
              :bankType="0"
            >
            </QuestionBankList>
          </el-tab-pane>
          
          <el-tab-pane label="大纲" name="third">
            <QuestionOutline 
              :type="'ks'"
              :list="paper.questionsList"
              @goAnchor="goAnchor"
							@copyClick="copyClick"
							@pasteClick="pasteClick"
            ></QuestionOutline>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-main style="overflow: visible;" class="exam-content">
        <!-- <p @click="clickPaper">打印paper</p> -->
        <div class="exam-heater">
          <TitleEditor v-if="showTitleEditor" class="exam-title"  :qid="id" :class="id" :value="paper.title" @childValueChange="val=>{ paper.title = val }" > </TitleEditor>
          
          <div class="exam-info">
            <p>试卷总分：{{paper.totalScore}}</p>
            <p class="exam-title-num">题目：{{paper.quesCount}}个</p>
          </div>
          <el-popover
            placement="bottom-start"
            width="600"
            trigger="manual"
            v-model="headVisible">
            <div >
              <el-form ref="formHeader" v-model="formHeader" label-width="60px">
                <!-- <el-form-item label="标题：">
                  <el-input v-model="formHeader.title"></el-input>
                </el-form-item> -->
                <el-form-item label="说明：">
                  <div class="wj-content">
                    <MyCKEditor 
                      v-if="headEditor === true"
                      id="edithHadContent" 
                      v-model="formHeader.depict"/>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button @click="headVisible = false">取消</el-button>
                  <el-button type="primary" @click="subFormHeader()">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
            <p slot="reference" class="exam-explain" @click="clickHead">添加考试说明（考试须知）</p>
          </el-popover>
        </div>

        <div class="no-content" v-show="paper.questionsList && paper.questionsList.length == 0">点击左侧题型，添加题目到此处</div>
        <ExamQuesTemplate ref="examQuesTemplate" :paper="paper" @submit="submit"></ExamQuesTemplate>
      </el-main>
    </el-container>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleSubmit"
      width="30%" :close-on-click-modal="false">
      <span>已完成编辑，是否立即发布？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toSetting" size="small" icon="el-icon-setting">设置</el-button>
        <el-button type="primary" @click="toReleaseExam" size="small" icon="el-icon-position">立即发布</el-button>
      </span>
    </el-dialog>
	<input type="file" style="display: none" id="uploadFile" @change="uploadFile" />
  </div>
</template>
<script>
import Paper from "@/components/examQuesTemplate/js/Paper.js"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import ExamQuesTemplate from "@/components/examQuesTemplate/index.vue"
import MyCKEditor from "@/components/ckedit/index"
import QuestionTypeList from "@/components/examQuesTemplate/questionTypeList.vue"
import QuestionBankList from "@/components/examQuesTemplate/questionBankList.vue"
import QuestionOutline from "@/components/examQuesTemplate/questionOutline.vue"

import qs from 'qs'
import { mapState } from "vuex"
import { v1 as UUID } from "uuid";
import AES from '@/util/AES.js';
export default {
  name: 'CreateExam',
  components: {
    MyCKEditor,
    TitleEditor,
    QuestionTypeList,
    QuestionBankList,
    ExamQuesTemplate,
    QuestionOutline
  },
  data() {
    return {
      value1: "简答题",
      value: true,
      headVisible: false,
      headEditor: false,
      num: 1,
      selectIndex: 0,
      paper: {},
      activeTabsName: 'first',
      
      typeObj: [
        {
          questionsTypeName: '个人信息',
          questionTypeList:[
            {
              label: "姓名",
              questionsTypeId: 600,
              infoName: 601,
              icon: 'zxwj-icon-xingming'
            },
            {
              label: "学号",
              questionsTypeId: 600,
              infoName: 602,
              icon: 'zxwj-icon-wodexuesheng'
            },
            {
              label: "专业",
              questionsTypeId: 600,
              infoName: 603,
              icon: 'zxwj-icon-shanchangzhuanye'
            },
            {
              label: "院系",
              questionsTypeId: 600,
              infoName: 604,
              icon: 'zxwj-icon-yuanxibumen'
            },
            {
              label: "学校",
              questionsTypeId: 600,
              infoName: 605,
              icon: 'zxwj-icon-xuexiao'
            },
            {
              label: "其他信息",
              questionsTypeId: 600,
              infoName: 606,
              icon: 'zxwj-icon-qita'
            },
          ]
        },{
          questionsTypeName: '考前准备',
          questionTypeList:[
            {
              label: "考前须知",
              questionsTypeId: 501,
              icon: 'zxwj-icon-wenhao'
            },
          ]
        },{
          questionsTypeName: '常用考试题型',
          questionTypeList:[
            {
              label: "单选题",
              questionsTypeId: 100,
              icon: 'zxwj-icon-danxuan_xuanzhong'
            },
            {
              label: "多选题",
              questionsTypeId: 101,
              icon: 'zxwj-icon-duoxuanxuanzhong'
            },
            {
              label: "判断题",
              questionsTypeId: 102,
              icon: 'zxwj-icon-icon-'
            },
            {
              label: "填空题",
              questionsTypeId: 204,
              icon: 'zxwj-icon-tiankongti'
            },
            {
              label: "简答题",
              questionsTypeId: 206,
              icon: 'zxwj-icon-jiandati'
            },
          ]
        },{
          questionsTypeName: '更多题型',
          questionTypeList:[
            {
              label: "上传文件",
              questionsTypeId: 210,
              icon: 'zxwj-icon-yunshangchuan'
            },
            {
              label: "多项填空",
              questionsTypeId: 207,
              icon: 'zxwj-icon-tiankongti'
            },
            {
              label: "横向填空",
              questionsTypeId: 208,
              icon: 'zxwj-icon-jiandati'
            },
            {
              label: "绘图题",
              questionsTypeId: 209,
              icon: 'zxwj-icon-huituguanlixinxi'
            },
            // {
            //   label: "上传图片",
            //   questionsTypeId: 211,
            //   icon: 'icon-shangchuantupian'
            // },
          ]
        },{
          questionsTypeName: '分页设置',
          questionTypeList:[
            {
              label: "一题一页",
              questionsTypeId: 404,
              icon: 'zxwj-icon-xiti'
            },
            {
              label: "分页",
              questionsTypeId: 402,
              icon: 'zxwj-icon-chaifenyemian'
            },
            {
              label: "段落说明",
              questionsTypeId: 401,
              icon: 'zxwj-icon-duanla'
            },
          ]
        },
      ],
      id: '', // 考试id
      createTime: '',
      formHeader: {
        title: '',
        depict: ''
      },
      operationTimer: '',
      countDown: 60,
      dialogVisibleSubmit: false,
      showTitleEditor: false,
			activeQuesIndex: -1, // 当前大纲选中的试题index 包含所有题型
			questionCopy: {}, // 复制到的试题
    }
  },
  watch:{
    'paper.questionsList': {
      handler(vnew, vold) {
        let total = 0
        let quesCount = 0
        let pageCount = 0
        if (this.paper.questionsList.length > 0) {
          total = this.paper.questionsList.reduce((total, item) => {
            if(item.score) {
              return total + item.score
            } else {
              return total
            }
          }, 0)
          this.paper.questionsList.forEach((info) =>{
            // console.log(info)
            if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
              pageCount++
            }
            if (this.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {       
              quesCount++
            }
          })
          this.$refs.examQuesTemplate.changeSort()
        }
        this.paper.pageCount = pageCount
        this.paper.quesCount = quesCount
        this.paper.totalScore = total
      },
      deep: true
    },
    'paper': {
      handler(vnew, vold) {
        // console.log('更新了')
        clearTimeout(this.operationTimer)
        this.timer()
        this.countDown = 60
      },
      deep: true
    }
  },
  computed:{
		...mapState(['examQuestionTypeArr']),
	},
  created() {
    if (sessionStorage.getItem("wid")){
      sessionStorage.removeItem("wid")
    }
    // 第三方路径携带examId start
    let id = this.$functions.getQueryStringhash('examId')
    if (id) {
      sessionStorage.setItem("examId", id)
    }
    // 第三方路径携带examId end

    this.initFunction()
    if(sessionStorage.getItem("examId")){
      this.id = sessionStorage.getItem("examId")
      this.getData()
    } else {
      this.examAdd()
    }
  },
  mounted() {
    // 获取创建时间
    this.createTime = this.$functions.GetDate()
    
    this.formHeader = {
      title: this.paper.title,
      depict: this.paper.depict
    }
    if(!sessionStorage.getItem('state')) {
      this.publishwj()
    }
  },
  methods: {
	  htmlToString(htmlStr) {
	  	return htmlStr.replace(/<\/?.+?\/?>|\r|\n|\s*/g, '');
	  },
    // 锚点定位
    goAnchor(aname, qid, index) {
			this.$nextTick(() => {
				let selector = `div[name=${aname}]`;
				var anchor = this.$el.querySelector(selector);
				if (anchor) {
					anchor.scrollIntoView({ block: 'center', behavior: 'smooth' });
				}
			});
      console.log(qid)
      if (qid) {
			  this.activeQuesIndex = this.paper.questionsList.findIndex(info => info.qid == qid)
			  this.setEditIndex(this.activeQuesIndex)
      } else {
        this.activeQuesIndex = -1
      }
		},
		setEditIndex(index) {
			this.paper.cancleEdit();
			if (index != undefined) {
				this.paper.questionsList[index].isedit = true;
			}
		},
		// 复制 将当前试题复制到模板
		copyClick() {
			this.questionCopy = this.paper.questionsList[this.activeQuesIndex]
			if (this.questionCopy?.qid){
				this.$message({
					message: '复制成功',
					type: 'success'
				})
				console.log(this.questionCopy)
			} else {
				this.$message({
					message: '请先选择试题',
					type: 'warning'
				});
			}
		},
		// 粘贴试题
		pasteClick() {
			this.paper.cancleEdit()
			this.paper.copyQuestion(this.questionCopy, this.activeQuesIndex)
			if (this.questionCopy?.qid){
				this.$message({
					message: '复制成功',
					type: 'success'
				})
			} else {
				this.$message({
					message: '暂无可粘贴的试题',
					type: 'warning'
				});
			}
		},
	  // 上传文件
	  uploadFile(data) {
	  	var objFile = document.getElementById('uploadFile');
	  	// var objFile = data.target
	  	if (objFile.value == '') {
	  		alert('不能空');
	  	}
	  
	  	var files = objFile.files; // 获取到文件列表
	  	if (files.length == 0) {
	  		alert('请选择文件');
	  	} else {
	  		// var reader = new FileReader() //新建一个FileReader
	  		var reader = new FileReader();
	  		// reader.readAsDataURL(files);
	  		reader.readAsText(files[0], 'UTF-8'); // 读取文件
	  		var self = this;
	  		reader.onload = function(e) {
	  			// 读取完文件之后会回来这里
	  			var fileString = e.target.result; // 读取文件内容
	  			var srt = AES.decrypt(fileString);
	  			console.log('11111111', srt);
	  			self.paper = JSON.parse(srt);
	  			// self.$emit('storage', 'two')
	  		};
	  		reader.onerror = function(e) {
	  			alert('文件读取失败，请检查。');
	  		};
	  		// reader.readAsBinaryString(f)
	  	}
	  },
	  // 导入数据
	  importData() {
	  	let element = document.getElementById('uploadFile');
	  	element.click();
	  },
	  exportData() {
	  	console.log(this.paper);
	  	var keys = AES.generatekey(16);
	  	let data = this.paper;
	  	// 加密
	  	var encrypts = AES.encrypt(JSON.stringify(data));
	  	// 解密
	  	// var dess = AES.decrypt(encrypts)
	  	let jsonObj = encrypts;
	  	// 创建a标签
	  	var elementA = document.createElement('a');
	  	// 文件的名称为时间戳加文件名后缀
	  	let title = JSON.parse(JSON.stringify(this.paper.title))
	  	elementA.download = this.htmlToString(title) + '_问卷.txt';
	  	elementA.style.display = 'none';
	  	// 生成一个blob二进制数据，内容为json数据
	  	var blob = new Blob([encrypts]);
	  	// 生成一个指向blob的URL地址，并赋值给a标签的href属性
	  	elementA.href = URL.createObjectURL(blob);
	  	document.body.appendChild(elementA);
	  	elementA.click();
	  	document.body.removeChild(elementA);
	  },
    // 引用题库试题
    quesFormBand(item) {
      console.warn(item.bid)
      this.paper.cancleEdit()
      let e = {...item}
      e.isedit = true
      e.bqid = e.qid
      e.qid = UUID()
      console.log(e)
      let index = -1
      this.paper.questionsList.forEach((info, i) => {
        if(this.paper.quesAtive && info.qid == this.paper.quesAtive) {
          index = i
        } else if (!this.paper.quesAtive) {
					this.paper.quesAtive = e.qid
          this.paper.questionsList.push(e)
        }
      })
      if (index != -1) {
        this.paper.questionsList.splice(index + 1, 0, e)
      }
      if (this.paper.questionsList.length == 0) {
        this.paper.questionsList.push(e)
      }
      console.log(this.paper.questionsList)
      this.quesQuoteNum(e.bqid)
    },
    // 增加试题引用次数
    quesQuoteNum(qid) {
      let that = this
      let params = {
        that: this,
        url: `${this.$config.service.examAddAddFrequency}?quesId=${qid}`,
        method: "GET",
        cb(res) {
          console.log(res)
        },
      };
      this.$util.request(params)
    },
    publishwj() {
      let data = qs.stringify({
        'id': this.id,
        'state': 1
      })
      let that = this
      let params = {
        that: this,
        url: `${this.$config.service.examProjectEditState}?${data}`,
        method: "POST",
        cb(res) {
          console.log(res)
        },
      };
      this.$util.request(params)
    },
    timer() {
      this.operationTimer = setTimeout(() => {
        // console.log(this.countDown)
        if (this.countDown > 0){
          this.countDown--
          this.timer()
        }else {
          this.submit()
        }
      }, 1000);
    },
    getData() {
      let that = this
      let params = {
        that: this,
        url: `${this.$config.service.examPaperQueryById}?id=${this.id}`,
        method: "GET",
        cb(res) {
          // console.log(res)
          if (res.code == 0) {
            // console.log(JSON.parse(res.resultBody.paperjson))
            let paper = JSON.parse(res.resultBody.paperjson)
            
            // console.log(paper)
            that.paper.depict = paper.depict
            that.paper.pageCount = paper.pageCount
            that.paper.quesAtive = paper.quesAtive
            that.paper.quesCount = paper.quesCount
            that.paper.questionsList = paper.questionsList ? paper.questionsList : []
            that.paper.title = paper.title
            that.paper.totalScore = paper.totalScore
						that.paper.endPageAdvanceMsg = paper.endPageAdvanceMsg;
						that.paper.endPageNormalMsg = paper.endPageNormalMsg;
						that.paper.endPageType = paper.endPageType;
            that.showTitleEditor = true
          }
        },
      };
      this.$util.request(params);
    },
    clickHead() {
      this.formHeader = {
        title: this.paper.title,
        depict: this.paper.depict
      }
      this.headVisible = !this.headVisible
      this.$nextTick(() => {
        this.headEditor = !this.headEditor
      })
    },
    subFormHeader() {
      this.headVisible = false
      setTimeout(() => {
        this.headEditor = false
      }, 500)
      this.paper.title = this.formHeader.title
      this.paper.depict = this.formHeader.depict
    },
    clickPaper(){
      console.log(this.paper)
    },
    // 个人信息类 动态绑定
    // 编辑选项 动态绑定
    spanBlur(index) {
      // console.log(index)
      // console.log(this.$refs.span[index])
      this.paper.questionsList[index].questionsName = this.$refs.span[index].innerHTML
    }, 
    sectionBlur(index) {
      this.paper.questionsList[index].questionsName = this.$refs.section[index].innerHTML
    }, 
    pageBlur(index) {
      this.paper.questionsList[index].questionsName = this.$refs.section[index].innerHTML
    },
    // 新增考试
    examAdd() {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.examProjectAdd}?paperType=1`,
        method: "post",
        cb(res) {
          that.id = res
          that.showTitleEditor = true
          sessionStorage.setItem("examId", res)
        },
      };
      this.$util.request(params);
    },
    submit(state, next) {
      // if(this.paper.questionsList.length > 0) {
        this.paper.questionsList.forEach(info => {
          if (info.questionsTypeId == 100 && info.scoringType == 2) {
            info.oidScoreArr = []
            info.scoreArr.forEach((item, index) => {
              if (typeof(item) == 'undefined') info.scoreArr[index] = 0
              info.optionList.forEach((el, elindex) => {
                if (index == elindex) {
                  // console.log(index)
                  info.oidScoreArr[index] = `${el.oid}@${info.scoreArr[index]}`
                }
              })
            })
          }
        })
        // console.log(this.paper)
        // console.log('触发')
        clearTimeout(this.operationTimer)
        let paperJson = JSON.parse(JSON.stringify(this.paper))
        paperJson.questionsList.forEach((info) => {
          // console.log(info)
          if(info.questionsTypeId == 101 && info.answer.length>0) {
            info.answer = info.answer.join(';')
          }else if(info.questionsTypeId == 101 && info.answer.length == 0) {
            info.answer = ''
          }
        })
        let that = this;
        let data = {
          id: this.id,
          paperjson: JSON.stringify(paperJson),
          createTime: this.createTime,
          updateTime: this.$functions.GetDate()
        }
        let params = {
          that: this,
          url: `${this.$config.service.examPaperAdd}`,
          method: "post",
          data: data,
          cb(res) {
            console.log(res)
            if (next) next()
            if (res.code == '0') {
              console.log('保存成功')
              if (state == 1) {
                that.dialogVisibleSubmit = true
              }
            } else {
              that.$message.error(res.message)
            }
          },
        };
        this.$util.request(params);
      // } else {
      //   this.$message({
      //     message: '请先添加题目',
      //     type: 'warning'
      //   });
      // }
    },
    toSetting() {
      this.dialogVisibleSubmit = false
      this.$router.push({path: '/examSetting'})
    },
    toReleaseExam(){
      this.dialogVisibleSubmit = false
      this.$router.push({path: '/sendTest'})
    },
    // 复制当前题目
    copyQuestion(ques, index){
      //新插入的问题设置为编辑状态
      this.paper.copyQuestion(ques,index);
    },

    initFunction() {
      //默认创建对象
      this.paper = new Paper();
      //this.paper.loadJson(json);
    },
		// 批量添加试题
		batchAddQues(list) {
			this.paper.questionsList = [...this.paper.questionsList, ...list]
			console.log(this.paper)
		},
    commonTopic(item) {

      if(item.questionsTypeId == 211) {
        this.$message({
          message: '此功能正待开发',
          type: 'warning'
        })
        return
      }
      if (item.questionsTypeId == 501 && this.paper.questionsList.length > 0){
        console.log(this.paper.questionsList)
        let qindex = this.paper.questionsList.findIndex((info) => info.questionsTypeId == 501)
        if(qindex != -1) {
          this.$message({
            message: '一个项目仅支持添加一个考前须知',
            type: 'warning'
          })
          return
        }
      }
      // //取消正在编辑的问题
      this.paper.cancleEdit();
        //新插入的问题设置为编辑状态
        if (item.questionsTypeId == 600) {
          this.paper.createQuestion(item.questionsTypeId, this.selectIndex, item.infoName);
        } else {
          this.paper.createQuestion(item.questionsTypeId, this.selectIndex);
        }
    },
  },
  beforeRouteLeave (to, from, next) {
    // console.log('路由跳转')
    this.submit(-1, next)
    clearTimeout(this.operationTimer)
  },
};
</script>
<style lang="scss" scoped>

/deep/.tox .tox-menu{
  z-index: 999 !important;
}
.conent{
  margin: 60px 0 0 80px;   
}
.no-content{
    width: 100%;
    background: #fff;
    padding: 120px 0;
    text-align: center;    
    margin-bottom: 5px;
    box-sizing: border-box;
    font-size: 16px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .16);
}
.aside{
  max-height: calc(100vh - 60px);
  width: 290px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0,.16);
  position: fixed;
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  overflow-y: auto;
  z-index: 1;
}
.exam-content{
  margin-left: 280px;
}
.exam-heater {
  position: relative;
  background-color: rgb(255, 255, 255);
  min-height: 80px;
  padding-top:26px;
  padding-bottom: 50px;
  line-height: 30px;
  font-size: 20px;
  text-align: center;
  border-radius: 4px;
  margin: 0  10px 5px 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0,.10);
}
.exam-title{
  display: inline-block;
}
.box-f{
  width: 80%;
  font-size: 16px;
  font-weight: bold;
  display: flex;
}
.box-icon i {
  padding: 0 10px;
}
.exam-title-num{
  margin-top: 30px;
  display: inline-block;
}
.exam-explain{
    position: absolute;
    left: 23px;
    bottom: 3px;
    line-height: 46px;
    padding: 0 20px;
    font-size: 16px;
    color: #3B6EE8;

    background-color: rgba(200, 230, 247, 1);
}
.exam-info{
  position: absolute;
  top:20px;
  right:30px;
  font-size: 16px;
  color: #169BD5;
}
.aside-left {
  padding-left: 25px;
}
</style>

<style lang="scss">
.subject-left, .subject-right{
  min-width: 370px;
}
.subject{
  width: 100%;
}

@media (max-width: 768px) {
  .subject-box {
    flex-direction: column;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (max-width: 992px) {
  .subject-box {
    flex-direction: column;
  }
}
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: 1452px) {
  .subject-box {
  }
}


</style>
<style lang="scss">
	.exportImport {
		height: 60px;
		line-height: 60px;
		position: absolute;
		top: 0px;
		right: 90px;
		z-index: 999;
		.exportStyle {
			margin-right: 20px;
			font-size: 18px;
			cursor: pointer;
			color: #909399;
		}
		.exportStyle:hover{
			color: #000000;
		}
		.importStyle {
			font-size: 18px;
			cursor: pointer;
			color: #909399;
		}
		.importStyle:hover{
			color: #000000;
		}
	}
</style>